import { render, staticRenderFns } from "./ModalTeamCreate.vue?vue&type=template&id=3150f41a&"
import script from "./ModalTeamCreate.vue?vue&type=script&lang=js&"
export * from "./ModalTeamCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports